import React, { useEffect, useState } from 'react'
import './DashboardHero.css'
import {AvailableGamesData, carouselDetails} from '../../../data'
import ph_arrow_right_light from '../../../assets/images/ph_arrow_right_light.svg';
import enterRightarrow from '../../../assets/images/enterRightarrow.svg'
import Carousel from 'react-bootstrap/Carousel';
import { useNavigate } from 'react-router-dom';
import { allGames } from '../../games/auxiliary/gamesAux';
import CustomSvg from '../../svgs/CustomSvg';
import { getRequest } from '../../apiRequests/requestApi';
import ComingSoonModal from "../../common/ComingSoonModal";




function DashboardHero({ isLeftBlockOpen, isRightBlockOpen }) {
    const navigate = useNavigate()
    const navigateTo = path => navigate(path)
    const goToAllUsers = () => navigateTo('/all-users')
    const goToSelectedGame = ({ id }) => navigateTo(`/games/selected-game/${id}`)

    const [gamesCount, setGamesCount] = useState(5)
    const [usersCount, setUsersCount] = useState(8)
    const [topGamers, setTopGamers] = useState([])
    const [loading, setLoading] = useState(true)
    const [showComingSoon, setShowComingSoon] = useState(false);
    const [comingSoonFeature, setComingSoonFeature] = useState("");

    useEffect(() => {
        const fetchTopGamers = async () => {
            try {
                const response = await getRequest("/top/gamers");
                if (response?.data) {
                    setTopGamers(response.data);
                }
            } catch (error) {
                console.error("Error fetching top gamers:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTopGamers();
    }, []);

    useEffect(() => {
        if((isRightBlockOpen && !isLeftBlockOpen) || (isLeftBlockOpen && !isRightBlockOpen)){
            setGamesCount(4)
            setUsersCount(7)
        
        }

        if(isRightBlockOpen && isLeftBlockOpen){
            setGamesCount(3)
            setUsersCount(5)
        }

        if(!isRightBlockOpen && !isLeftBlockOpen){
            setGamesCount(5)
            setUsersCount(8)
        }
    }, [isRightBlockOpen, isLeftBlockOpen])

    const onSelectGame = ({ game }) => goToSelectedGame({ id: game.id })

    const playLudo = () => {
        const ludoGame = filterGames({ id: 'ludo' })
        return goToSelectedGame({ id: ludoGame.id })
    }

    const playChess = () => {
        const chessGame = filterGames({ id: 'chess' })
        return goToSelectedGame({ id: chessGame.id })
    }

    const playScrabble = () => {
        const scrabbleGame = filterGames({ id: 'scrabble' })
        return goToSelectedGame({ id: scrabbleGame.id })
    }

    const playSnooker = () => {
        const snookerGame = filterGames({ id: 'snooker' })
        return goToSelectedGame({ id: snookerGame.id })
    }

    const filterGames = ({ id }) => {
        const filtered = allGames.filter(game => game.id == id)
        return filtered[0]
    }
    
    const handleGameSelect = (game) => {
        // Check if the game is Snooker or Ludo
        if (game.id === "snooker" || game.id === "ludo") {
            setComingSoonFeature(`${game.id} Game`);
            setShowComingSoon(true);
        } else {
            navigate(`/games/selected-game/${game.id}`);
        }
    };

    return (
        <div className='d-flex w-100 align-items-center justify-content-center'>
            <div className='availablegamescontainer'>
                <div className='col-12'>
                    <div style={{position: 'relative', paddingTop: '56.25%'}}> {/* 16:9 aspect ratio container */}
                        <Carousel className='w-100' style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0}}
                                  indicators={false}>
                            <Carousel.Item className='bg-img carousel-1-bg h-100'>
                                <div className='h-100 d-flex align-items-center'>
                                    <div className='px-lg-5 px-md-5 px-3 w-100'>
                                        <div className='d-flex flex-column justify-content-between carouselleft'
                                             style={{gap: '2rem'}}>
                                            <div>
                                                <div className='gamestitles'>Ludo<span
                                                    className='additionaltext'>Quest</span></div>
                                                <div className='gamesdescription font-family-poppins'>Roll the Dice,
                                                    Take Friends Down
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-start'>
                                                <div onClick={() => handleGameSelect({id: 'ludo'})}
                                                     className='enterbutton px-3 py-1 clickable d-flex justify-content-between'>Enter <img
                                                    src={enterRightarrow} alt='arrow'/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Item>

                            <Carousel.Item className='bg-img carousel-2-bg h-100'>
                                <div className='h-100 d-flex align-items-center'>
                                    <div className='px-lg-5 px-md-5 px-3 w-100'>
                                        <div className='d-flex flex-column justify-content-between carouselleft'
                                             style={{gap: '2rem'}}>
                                            <div>
                                                <div className='gamestitles'>Chess<span
                                                    className='additionaltext'>Duel</span></div>
                                                <div className='gamesdescription font-family-poppins'>Join the battle of
                                                    minds
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-start'>
                                                <div onClick={() => handleGameSelect({id: 'chess'})}
                                                     className='enterbutton px-3 py-1 clickable d-flex justify-content-between'>Enter <img
                                                    src={enterRightarrow} alt='arrow'/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Item>

                            <Carousel.Item className='bg-img carousel-3-bg h-100'>
                                <div className='h-100 d-flex align-items-center'>
                                    <div className='px-lg-5 px-md-5 px-3 w-100'>
                                        <div className='d-flex flex-column justify-content-between carouselleft'
                                             style={{gap: '2rem'}}>
                                            <div>
                                                <div className='d-flex align-items-center gap-2 flex-wrap'>
                                                    <h2 className='gamestitles m-0 p-0'>Scrabble</h2>
                                                    <h2 className='gamestitles additionaltext m-0 p-0'>Clash</h2>
                                                </div>
                                                <div className='gamesdescription font-family-poppins'>Craft words,
                                                    compete, claim victory.
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-start'>
                                                <div onClick={() => handleGameSelect({id: 'scrabble'})}
                                                     className='enterbutton px-3 py-1 clickable d-flex justify-content-between'>Enter <img
                                                    src={enterRightarrow} alt='arrow'/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Item>

                            <Carousel.Item className='bg-img carousel-4-bg h-100'>
                                <div className='h-100 d-flex align-items-center'>
                                    <div className='px-lg-5 px-md-5 px-3 w-100'>
                                        <div className='d-flex flex-column justify-content-between carouselleft'
                                             style={{gap: '2rem'}}>
                                            <div>
                                                <div className='d-flex gap-2 align-items-center flex-wrap'>
                                                    <h2 className='gamestitles m-0 p-0'>Snooker</h2>
                                                    <h2 className='gamestitles additionaltext m-0 p-0'>Strike</h2>
                                                </div>
                                                <div className='gamesdescription font-family-poppins'>Pot balls, score
                                                    high, reign supreme
                                                </div>
                                            </div>
                                            <div className='d-flex  align-items-center justify-content-start'>
                                                <div  onClick={() => handleGameSelect({id: 'snooker'})}
                                                     className='enterbutton margin-left-3 px-3 py-1 clickable d-flex justify-content-between'>Enter <img
                                                    src={enterRightarrow} alt='arrow'/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Item>
                        </Carousel>
                    </div>
                </div>


                <div className='d-flex combinations mb-2'>
                    <div className='Availabletitle font-family-poppins'>Available Games</div>
                    <div
                            className='availablegeneral d-flex  gap-3'>
                        {allGames.slice(0, gamesCount).map((availablegames) => {
                            // If the title is more than 9 letters, cut to first word only
                            const displayTitle = availablegames.title.replace(/\s+/g, '').length > 9
                                ? availablegames.title.split(' ')[0]
                                : availablegames.title;
                            return (
                                <div
                                    onClick={() => handleGameSelect(availablegames)}
                                  >
                                    <div
                                        className={`col-12 ${gamesCount == 5 ? 'col-lg-12' : 'col-lg-11 col-md-11'} availableContainer mt-4`}
                                        id={availablegames.id}>
                                        <div className='col-12'>
                                            
                                            <img src={availablegames.img} className='mb-4 col-12'  style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "1rem",
                  border: `1px solid #E7FDB7`,
                                            }}/>
                                        </div>
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <div className='gamesname mb-2'>{displayTitle}</div>
                                                <div
                                                    className='gameswriteup font-family-poppins extra-small-txt'>{availablegames.caption}</div>
                                            </div>

                                            <div className='anchorarrow'>
                                                <CustomSvg name="arrow-right" color={availablegames.arrowColor}
                                                        width={'16px'} height={'16px'}/>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                

                <div>
                    <div className='d-flex justify-content-between '>
                        <div className='font-family-poppins topgamertitle'>Top Gamers</div>
                        <div onClick={goToAllUsers} className='clickable'><p className='font-family-poppins seelink topgamersseeall'> see all <img  src={ph_arrow_right_light} alt='.'/></p></div>
                    </div>

                    <div className='d-flex align-items-center gap-4 mb-4'>
                        {loading ? (
                            <div className="text-center w-100">Loading...</div>
                        ) : topGamers.slice(0, usersCount).map((topgamer) => (
                            <div className='' key={topgamer._id}>
                                <img 
                                    src={topgamer.userInfo.avatar || topgamer.userInfo.profile} 
                                    alt={topgamer.userInfo.username} 
                                    className='rounded-circle mb-2'
                                    style={{width: '50px', height: '50px', objectFit: 'cover'}}
                                />
                                <div className='font-family-poppins txt-FFF'> {topgamer.userInfo.username.slice(0, 5)}</div>
                            </div>
                        ))}
                    </div>
                </div>


            </div>
            <ComingSoonModal
                show={showComingSoon}
                onHide={() => setShowComingSoon(false)}
                feature={comingSoonFeature}
            />
        </div>
    )
}

export default DashboardHero